import { mode } from '@chakra-ui/theme-tools';

/** Contraste visible sobre fondo gray.50 de la app (no usar gray.50 en filas). */
const zebraTbody = (props) => ({
  tbody: {
    tr: {
      '&:nth-of-type(odd)': {
        td: {
          bg: mode('gray.50', 'whiteAlpha.100')(props),
        },
      },
      '&:nth-of-type(even)': {
        td: {
          bg: mode('white', 'navy.800')(props),
        },
      },
      td: {
        borderBottomWidth: '1px',
        borderBottomColor: mode('gray.200', 'whiteAlpha.100')(props),
        transition: 'background 0.12s ease',
      },
      '&:hover td': {
        bg: mode('gray.200', 'whiteAlpha.300')(props),
      },
    },
  },
});

const compactCells = {
  th: {
    py: 1.5,
    px: 2,
    lineHeight: '1.2',
  },
  td: {
    py: 1,
    px: 2,
    lineHeight: '1.25',
  },
};

export const tableStyles = {
  components: {
    Table: {
      baseStyle: compactCells,
      variants: {
        simple: (props) => ({
          ...zebraTbody(props),
          ...compactCells,
          th: {
            ...compactCells.th,
            borderBottomWidth: '1px',
            borderColor: mode('gray.200', 'whiteAlpha.200')(props),
            textTransform: 'none',
            letterSpacing: 'normal',
            fontWeight: 'semibold',
            color: mode('gray.700', 'gray.200')(props),
          },
          td: {
            ...compactCells.td,
            color: mode('gray.700', 'gray.200')(props),
          },
        }),
        striped: (props) => ({
          ...zebraTbody(props),
        }),
      },
    },
  },
};
